import Vue from "vue";
// import '@fes/mo-bridge'; // mm
// import '@fes/mo-mock'; // mk
import "common-bridge/dist/index";

import store from "./store";
import "./app.scss";
import App from "./App.vue";
import router from "./router";
/* eslint-disable */
import monitor from "@monitor/core";
import performance from "@monitor/performance";

let domainBlackList = []; 
function init(userId, apiUrl) {
  Vue.use(monitor, {
    dsn: apiUrl,
    userId,
    apikey: "1000629",
    silentWhiteScreen: true, // 开启白屏检测
    // skeletonProject: true, // 项目有骨架屏
    repeatCodeError: true, // 开启错误上报去重
    silentXhr: true, // 取消监听xhr请求报错
    silentFetch: true, // 取消监听fetch请求报错
    useXhrUpload: true,
    ignorePfNames: ["longTask", "resourceList"],
    beforeDataReport(data) {
      return {
        msg: data,
        clientType: 1,
        appName: "duidui"
      };
    }
  });
  monitor.use(performance, {}); // 安装性能插件
}

/* eslint-disable */
// export const openMonitor = ({
//   uid = "",
//   apiUrl = "https://melon-gateway.immomo.com/mdp/mdp-log/log",
//   blackList = []
// }) => {
//   domainBlackList = blackList.length ? blackList : domainBlackList;
//   const curDomain = window.location.hostname;
//   const search = new URLSearchParams(window.location.search);
//   const ifMonitor = search.get("_monitor");
//   console.log("init******", uid);
//   if (!domainBlackList.includes(curDomain)) {
//     init(uid, apiUrl);
//   } else if (ifMonitor) {
//     init(uid, apiUrl);
//   } else {
//     console.log("不满足上报条件", curDomain, ifMonitor);
//   }
// };

// 监控
// (async () => {
//   let uid = "locals";

//   mm.invoke("user", "userinfo", {}, res => {
//     uid = res.data.uid;
//     openMonitor({
//       uid
//     });
//   });
// })();

/* eslint-disable */
function getPublicPath() {
  const {
    location: { hostname, pathname }
  } = window;
  const path = pathname.replace(/([^\.\/\\]+)\.([a-z]+)$/i, "");
  if (hostname === "test-mvip.immomo.com") {
    return `https://test-g.momocdn.com${path}`;
  }
  if (hostname === "mvip.immomo.com") {
    return `https://g.momocdn.com${path}`;
  }
  if (hostname === "dev.mvip.immomo.com") {
    return "/fep/build/";
  }
  return "/";
}

Vue.config.productionTip = false;

const publicPath = getPublicPath();

__webpack_public_path__ = publicPath;

router.beforeEach((to, from, next) => {
  const {
    location: { hostname, pathname, search, origin }
  } = window;
  if (to.fullPath === "/privacy://") {
    next("/privacy");
  } else {
    next();
  }
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
